const DocumentExcelIcon = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.086 0C12.3511 0 12.6053 0.105254 12.7928 0.292628L18.7068 6.20218C18.8945 6.38974 19 6.6442 19 6.90955V17.6667C19 18.9553 17.9344 20 16.62 20H4.38C3.06556 20 2 18.9553 2 17.6667V2.33333C2 1.04467 3.06556 0 4.38 0H12.086Z"
      fill="#8E33FF"
    />
    <g filter="url(#filter0_d_2175_155475)">
      <path
        d="M18.0774 6.07004C18.2339 6.22782 18.1222 6.49609 17.8999 6.49609H15C13.7113 6.49609 12.5488 5.36261 12.5488 4.10613V1.10315C12.5488 0.879931 12.8191 0.768615 12.9763 0.927098L18.0774 6.07004Z"
        fill="white"
        fill-opacity="0.24"
        shape-rendering="crispEdges"
      />
    </g>
    <path
      d="M12.4979 8L12.4978 8.0056L12.5 8.00563V15H11.9168L11.9168 14.9991H10.1632L9.58017 15L9.58003 14.9991H8.42584L7.84274 15L7.84271 14.9991H6.08506L5.50205 15L5.50193 14.9991L5.50084 14.4164L5.50193 14.4163V12.6552L5.50044 12.0725L5.50193 12.0723V10.3112L5.5 10.3114V9.72849L5.50193 9.72838V8.58284L5.5 8.58286V8H12.4979ZM7.84271 12.6552H6.08506V14.4163H7.84271V12.6552ZM9.58003 12.6552H8.42584V14.4163H9.58003V12.6552ZM11.9168 12.6552H10.1632V14.4163H11.9168V12.6552ZM7.84271 10.3112H6.08506V12.0723H7.84271V10.3112ZM9.58003 10.3112H8.42584V12.0723H9.58003V10.3112ZM11.9168 10.3112H10.1632V12.0723H11.9168V10.3112ZM11.9168 8.58284H6.08506V9.72838H11.9168V8.58284Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_2175_155475"
        x="11.5488"
        y="0.853516"
        width="7.60156"
        height="7.64258"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2175_155475" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2175_155475" result="shape" />
      </filter>
    </defs>
  </svg>
);

export default DocumentExcelIcon;
